export default "__VITE_ASSET__CTPtO26J__"